module.exports = __webpack_public_path__ + "static/media/secretCitadel_2.effectsResult_faces-p-1080.a1b54f80.jpeg";